import ThanksForBooking from './ThanksForBooking.component';
export default ThanksForBooking;